module.exports = __webpack_public_path__ + "static/media/itgetsbetter.9c1a3d0b.png";